import accounting from 'accounting';

const LOCALES_WITH_COMMA = ['pl', 'ua', 'ru'];
const LOCALE = document.querySelector('html').getAttribute('lang') || 'en';

export const AccountingConfig = () => {
    const decimalSign = LOCALES_WITH_COMMA.includes(LOCALE) ? ',' : '.';

    accounting.settings.number = {
        precision: 2,
        thousand: "",
        decimal: decimalSign
    };
};
